import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import image2 from "../images/Images Webp/femme1.webp";
import image3 from "../images/Images Webp/tinywow_img_man_office_writing_paper_60034854.webp";
import image4 from "../images/Images Webp/Hayya3.webp";
import image5 from "../images/Images Webp/frequently.webp";
import image6 from "../images/Images Webp/blog3.webp";
import image7 from "../images/Images Webp/tinywow_I93A2687_59944286.webp";
import image8 from "../images/Images Webp/weddingDay.webp";
import image9 from "../images/Images Webp/Blog-1.webp";
import image10 from "../images/Images Webp/tinywow_img_groom_puts_wedd_60034854.webp";
import videoA from "../images/Images Webp/videos/video_a.mp4";
import videoD from "../images/Images Webp/videos/video_d.mp4";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import React, { lazy, Suspense } from "react";
import {
  Card,
  CardBody,
  CardFooter,
  Typography,
  Button,
} from "@material-tailwind/react";
import Cookies from "js-cookie";
import CookieNoticePopup from "./popups/CookieNoticePopup";
const Footer = lazy(() => import("./Footer"));

const FeatureCard = ({ title, icon, route }) => (
  <Card className="mt-6 xl:w-72 lg:w-60 md:w-56 sm:w-56 h-44 transform transition-all duration-500 ease-in-out group hover:scale-105 hover:bg-pink-600 hover:h-48 hover:shadow-sm hover:shadow-blue-950 relative overflow-hidden bg-slate-100">
    <CardBody className="transition duration-500 ease-in-out">
      <div className="mb-2 h-12 w-12 text-gray-900 transition duration-500 ease-in-out group-hover:text-white">
        {icon}
      </div>
      <Typography
        variant="h5"
        color="blue-gray"
        className="text-lg transition duration-500 ease-in-out group-hover:text-white"
      >
        {title}
      </Typography>
    </CardBody>
    <CardFooter className="pt-0 transition-all duration-500 ease-in-out">
      <a
        href={route}
        className="inline-block opacity-0 translate-y-8 group-hover:translate-y-0 group-hover:opacity-100 transition duration-500 ease-in-out"
      >
        <Button
          size="sm"
          variant="text"
          className="flex items-center gap-2 text-pink-600 group-hover:text-white"
        >
          Learn More
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className="h-4 w-4 transition duration-500 ease-in-out group-hover:text-white"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
            />
          </svg>
        </Button>
      </a>
    </CardFooter>
  </Card>
);

FeatureCard.propTypes = {
  number: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  blueBackground: PropTypes.bool,
  icon: PropTypes.element.isRequired,
  route: PropTypes.string.isRequired,
};

// Define FeatureCarousel component
const FeatureCarousel = ({ features }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section className="pt-10 pb-11 font-bold text-zinc-600">
      <Slider {...settings}>
        {features.map((feature, index) => (
          <div
            key={index}
            className="p-8 flex justify-center items-center max-w-screen-sm w-full"
          >
            <FeatureCard {...feature} />
          </div>
        ))}
      </Slider>
    </section>
  );
};

FeatureCarousel.propTypes = {
  features: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      icon: PropTypes.element.isRequired,
      description: PropTypes.string,
      blueBackground: PropTypes.bool,
      number: PropTypes.string,
      route: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default function Home() {
  const { t } = useTranslation();
  const [showCookieNotice, setShowCookieNotice] = useState(
    !Cookies.get("cookiesAccepted")
  );
  const handleDismissCookieNotice = () => {
    setShowCookieNotice(false);
    Cookies.set("cookiesAccepted", "true", { expires: 1 });
  };

  const features = [
    {
      number: "01.",
      title: t("Checklist & Budget Tracker"),
      description: t(
        "Stay organized with our comprehensive checklist and manage your budget effectively."
      ),
      icon: (
        <svg
          className="w-10 h-10 text-black transition duration-500 ease-in-out group-hover:text-white"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="10"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M15 4h3a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3m0 3h6m-6 7 2 2 4-4m-5-9v4h4V3h-4Z"
          />
        </svg>
      ),
      route: "/dashboard/budget-tracker",
    },
    {
      number: "02.",
      title: t("AI Wedding Assistant"),
      description: t(
        "Get personalized tips and recommendations to streamline your wedding planning."
      ),
      icon: (
        <svg
          className="w-10 h-10 text-black transition duration-500 ease-in-out group-hover:text-white"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="10"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M12 18.5A2.493 2.493 0 0 1 7.51 20H7.5a2.468 2.468 0 0 1-2.4-3.154 2.98 2.98 0 0 1-.85-5.274 2.468 2.468 0 0 1 .92-3.182 2.477 2.477 0 0 1 1.876-3.344 2.5 2.5 0 0 1 3.41-1.856A2.5 2.5 0 0 1 12 5.5m0 13v-13m0 13a2.493 2.493 0 0 0 4.49 1.5h.01a2.468 2.468 0 0 0 2.403-3.154 2.98 2.98 0 0 0 .847-5.274 2.468 2.468 0 0 0-.921-3.182 2.477 2.477 0 0 0-1.875-3.344A2.5 2.5 0 0 0 14.5 3 2.5 2.5 0 0 0 12 5.5m-8 5a2.5 2.5 0 0 1 3.48-2.3m-.28 8.551a3 3 0 0 1-2.953-5.185M20 10.5a2.5 2.5 0 0 0-3.481-2.3m.28 8.551a3 3 0 0 0 2.954-5.185"
          />
        </svg>
      ),
      route: "/dashboard/profile",
    },
    {
      number: "03.",
      title: t("Notary Matching"),
      description: t(
        "Connect with experienced notaries for legal advice and document authentication."
      ),
      icon: (
        <svg
          className="w-10 h-10 text-black transition duration-500 ease-in-out group-hover:text-white"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="10"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M8 7H5a2 2 0 0 0-2 2v4m5-6h8M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m0 0h3a2 2 0 0 1 2 2v4m0 0v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-6m18 0s-4 2-9 2-9-2-9-2m9-2h.01"
          />
        </svg>
      ),
      route: "/dashboard/contact-notaire",
    },
    {
      number: "04.",
      title: t("Tawkil Service"),
      description: t(
        "Delegate legal tasks to qualified representatives for efficiency and peace of mind."
      ),
      icon: (
        <svg
          className="w-10 h-10 text-black transition duration-500 ease-in-out group-hover:text-white"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="10"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M18 5V4a1 1 0 0 0-1-1H8.914a1 1 0 0 0-.707.293L4.293 7.207A1 1 0 0 0 4 7.914V20a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5M9 3v4a1 1 0 0 1-1 1H4m11.383.772 2.745 2.746m1.215-3.906a2.089 2.089 0 0 1 0 2.953l-6.65 6.646L9 17.95l.739-3.692 6.646-6.646a2.087 2.087 0 0 1 2.958 0Z"
          />
        </svg>
      ),
      route: "/dashboard/tawkil-service",
    },
    {
      number: "05.",
      title: t("Invitation Templates"),
      description: t(
        "Choose from professionally designed options, customize with your details, preview, and securely pay online directly on our platform."
      ),
      icon: (
        <svg
          className="w-10 h-10 text-black transition duration-500 ease-in-out group-hover:text-white"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="10"
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <path d="M2.038 5.61A2.01 2.01 0 0 0 2 6v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6c0-.12-.01-.238-.03-.352l-.866.65-7.89 6.032a2 2 0 0 1-2.429 0L2.884 6.288l-.846-.677Z" />
          <path d="M20.677 4.117A1.996 1.996 0 0 0 20 4H4c-.225 0-.44.037-.642.105l.758.607L12 10.742 19.9 4.7l.777-.583Z" />
        </svg>
      ),
      route: "/DMariageInvitation",
    },
    {
      number: "06.",
      title: t("Mood Board Creation"),
      description: t(
        "Visualize and plan your dream wedding with our easy-to-use mood board creator."
      ),
      icon: (
        <svg
          className="w-10 h-10 text-black transition duration-500 ease-in-out group-hover:text-white"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="10"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M12 7h.01m3.486 1.513h.01m-6.978 0h.01M6.99 12H7m9 4h2.706a1.957 1.957 0 0 0 1.883-1.325A9 9 0 1 0 3.043 12.89 9.1 9.1 0 0 0 8.2 20.1a8.62 8.62 0 0 0 3.769.9 2.013 2.013 0 0 0 2.03-2v-.857A2.036 2.036 0 0 1 16 16Z"
          />
        </svg>
      ),
      route: "/dashboard/profile",
    },
    {
      number: "07.",
      title: t("Blogs et interviews "),
      description: t(
        "Stay informed and inspired with expert advice, real wedding stories, and tips."
      ),
      icon: (
        <svg
          className="w-10 h-10 text-black transition duration-500 ease-in-out group-hover:text-white"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="10"
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            fillRule="evenodd"
            d="M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11.5c.07 0 .14-.007.207-.021.095.014.193.021.293.021h2a2 2 0 0 0 2-2V7a1 1 0 0 0-1-1h-1a1 1 0 1 0 0 2v11h-2V5a2 2 0 0 0-2-2H5Zm7 4a1 1 0 0 1 1-1h.5a1 1 0 1 1 0 2H13a1 1 0 0 1-1-1Zm0 3a1 1 0 0 1 1-1h.5a1 1 0 1 1 0 2H13a1 1 0 0 1-1-1Zm-6 4a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Zm0 3a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1ZM7 6a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H7Zm1 3V8h1v1H8Z"
            clipRule="evenodd"
          />
        </svg>
      ),
      route: "/blogs",
    },
    {
      number: "08.",
      title: t("Customer Support"),
      description: t(
        "Receive dedicated assistance from our support team throughout your planning journey."
      ),
      icon: (
        <svg
          className="w-10 h-10 text-black transition duration-500 ease-in-out group-hover:text-white"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="10"
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            fillRule="evenodd"
            d="M12 2a7 7 0 0 0-7 7 3 3 0 0 0-3 3v2a3 3 0 0 0 3 3h1a1 1 0 0 0 1-1V9a5 5 0 1 1 10 0v7.083A2.919 2.919 0 0 1 14.083 19H14a2 2 0 0 0-2-2h-1a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h1a2 2 0 0 0 1.732-1h.351a4.917 4.917 0 0 0 4.83-4H19a3 3 0 0 0 3-3v-2a3 3 0 0 0-3-3 7 7 0 0 0-7-7Zm1.45 3.275a4 4 0 0 0-4.352.976 1 1 0 0 0 1.452 1.376 2.001 2.001 0 0 1 2.836-.067 1 1 0 1 0 1.386-1.442 4 4 0 0 0-1.321-.843Z"
            clipRule="evenodd"
          />
        </svg>
      ),
      route: "/contactUs",
    },
  ];

  function QuestionCard({ question }) {
    const [isOpen, setIsOpen] = useState(false);

    return (
      <div className="border-b border-gray-200">
        <button
          className="w-full flex justify-between items-center py-4 px-2 text-left text-lg font-medium text-gray-900 hover:text-pink-600 focus:outline-none sm:px-4"
          onClick={() => setIsOpen(!isOpen)}
        >
          <span className="flex-1 text-2xl">{question.question}</span>
          <svg
            className={`w-5 h-5 transform transition-transform ${
              isOpen ? "rotate-180" : "rotate-0"
            }`}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </button>
        <div
          className={`overflow-hidden transition-max-height duration-500 ease-in-out ${
            isOpen ? "max-h-screen" : "max-h-0"
          }`}
        >
          <p className="py-4 px-2 text-black text-lg sm:px-4">
            {question.answer}
          </p>
        </div>
      </div>
    );
  }

  const questions = [
    {
      question: t("faq.whatIsHayya"),
      answer: t("faq.whatIsHayyaAnswer"),
    },
    {
      question: t("faq.howToGetStarted"),
      answer: t("faq.howToGetStartedAnswer"),
    },
    {
      question: t("faq.notaryMatchingService"),
      answer: t("faq.notaryMatchingServiceAnswer"),
    },
    {
      question: t("faq.weddingChecklist"),
      answer: t("faq.weddingChecklistAnswer"),
    },
    {
      question: t("faq.aiWeddingAssistant"),
      answer: t("faq.aiWeddingAssistantAnswer"),
    },
    {
      question: t("faq.contactCustomerSupport"),
      answer: t("faq.contactCustomerSupportAnswer"),
    },
  ];

  QuestionCard.propTypes = {
    question: PropTypes.shape({
      question: PropTypes.string.isRequired,
      answer: PropTypes.string.isRequired,
    }).isRequired,
  };

  return (
    <div>
      <div>
        <div className="responsive flex flex-col">
          <div className="flex flex-col md:flex-row items-center mx-5">
            <div className="flex-grow">
              <img
                src={image2}
                alt="image 3"
                className="min-h-64 object-cover rounded-lg"
              />
            </div>
            <div className="w-3/2 pl-10 flex items-center justify-center">
              <div className="flex-2 text-center">
                <h1 className="lg:text-7xl md:text-4xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                  {t("Making Wedding Dreams Come True")}{" "}
                  <span className="animate-pulse inline-block">&#10084;</span>
                </h1>
                <p className="mt-6 lg:text-2xl leading-8 text-gray-600">
                  {t(
                    "Laying the foundation for your love story? Our quiz helps couples find the perfect marriage regime that suits your needs.Just a few clicks to ensure you're on the same page!"
                  )}
                </p>
                <div className="mt-10 flex items-center justify-center gap-x-6">
                  <Link
                    to="/quizz"
                    className="rounded-md bg-pink-600 px-3.5 py-2.5 md:text-sm lg:text-2xl font-semibold text-white shadow-sm hover:bg-blue-950 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 transform hover:scale-105 transition duration-500 ease-in-out md:flex-shrink-0 lg:flex-shrink-0"
                  >
                    {t("Take the quiz")}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Second Section */}
        <div className="flex flex-col md:flex-row-reverse gap-5 md:gap-16 pt-16 mx-5 md:mx-16">
          <div className="flex flex-col w-full md:w-6/12 md:h-full sm:h-full mt-10 md:mt-0">
            <img
              loading="lazy"
              src={image7}
              alt="Our Process to Obtain Service"
              className="w-full aspect-[1.45]  rounded-lg hover:scale-105 transition duration-500 ease-in-out"
            />
          </div>
          <div className="flex flex-col w-full md:w-6/12 mt-32 md:mt-0">
            <div className="flex flex-col items-center justify-center h-full pt-16 pb-20">
              <h1 className="text-lg md:text-xl text-center text-stone-700">
                {t("Why Hayya?")}
              </h1>
              <div className="mt-4 md:ml-0 text-center">
                <h2 className="text-xl md:text-3xl font-bold tracking-tight text-gray-900">
                  {t("We’re changing the way people get married.")}
                </h2>
              </div>
              <p className="mt-4 text-gray-700 text-lg text-center">
                {t(
                  "At Hayya, our mission is to simplify the wedding planning process so you can focus on what truly matters—celebrating your love. We understand that wedding preparation can be overwhelming, which is why we offer a comprehensive platform that covers all your needs,from legal services to personalized planning tools.When it comes to Wedding preparation, the word (choice) is easy, Hayya."
                )}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col items-center justify-center h-full pt-16 ">
        <h1 className="text-base md:text-lg lg:text-xl text-center text-stone-700">
          {t("CORE FEATURES")}
        </h1>
        <div className="mt-4 md:ml-0 text-center">
          <h2 className="text-lg md:text-2xl lg:text-3xl font-bold tracking-tight text-gray-900">
            {t(
              "Discover the Ultimate Marriage Experience in Tunisia: Explore Our Latest Features!"
            )}
          </h2>
        </div>
      </div>
      {/* features */}
      <FeatureCarousel features={features} />

      {/*background image*/}
      <section
        className="relative flex flex-col justify-center px-1 text-center text-white text-[200px] max-md:text-4xl  "
        style={{
          backgroundImage: `url(${image4})`,
          height: "700px",
          backgroundAttachment: "fixed",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <div className="relative flex flex-col justify-center min-h-full max-md:max-w-full max-md:text-4xl">
          <h1 className="relative justify-center items-center w-full h-full flex bg-black bg-opacity-50 max-md:px-5 max-md:pt-10 max-md:max-w-full max-md:text-4xl">
            HAYYA For Life
          </h1>
        </div>
      </section>
      {/*under backgroundimage section */}
      <div className="pt-16">
        <div className="flex flex-col md:flex-row mx-4 md:mx-0">
          {/* Left Section */}
          <div className="md:w-1/2 md:pr-8">
            <div className="flex flex-col items-center justify-center h-full pt-16 pb-20">
              <h1 className="text-lg md:text-xl text-center text-stone-700">
                {t("Legal Section")}
              </h1>
              <div className="mt-4 md:ml-0 text-center">
                <h2 className="text-xl md:text-3xl font-bold tracking-tight text-gray-900">
                  {t(
                    "Protect Your Rights and Responsibilities When Getting Married in"
                  )}
                  <br />
                  {t("Tunisia.")}
                </h2>
              </div>
              <p className="mt-4 text-gray-700 text-lg text-center">
                {t(
                  "Comprehensive guidance and tools to ensure your marriage is legally recognized and your interests are safeguarded."
                )}
              </p>
              <Link
                to="/LegalEducation"
                className="mt-6 px-6 py-3 md:px-8 md:py-4 text-lg md:text-xl text-white bg-pink-600 rounded-lg hover:bg-blue-950 hover:scale-105 transition duration-500 ease-in-out"
              >
                {t("Explore More")}
              </Link>
            </div>
          </div>

          {/* Right Section */}
          <div className="md:w-1/2 md:pl-8 pb-12">
            <div className="flex flex-col gap-8 md:ml-16 mt-10">
              {/* Card 1 */}
              <Link to="/LegalEducation">
                <div className="relative overflow-hidden flex-col justify-center items-end rounded-lg shadow-sm bg-white  hover:scale-105 transition duration-500 ease-in-out">
                  <img
                    src={image3}
                    alt="image3"
                    className="object-cover w-full h-64 md:h-80 rounded-t-2xl hover:scale-105 transition duration-500 ease-in-out"
                  />
                  <div className="absolute inset-0 flex flex-col justify-center items-center px-6 py-8 rounded-b-2xl">
                    <div className="text-xl md:text-2xl font-bold text-center text-white">
                      {t("Notary Matching")}
                    </div>
                    <div className="mt-4 text-center text-white">
                      {t(
                        "Personalized matching with experienced notaries and convenient scheduling for easy consultations."
                      )}
                    </div>
                  </div>
                </div>
              </Link>

              {/* Card 2 */}
              <div className="relative overflow-hidden flex-col justify-center items-end rounded-lg shadow-sm bg-white hover:scale-105 transition duration-500 ease-in-out">
                <img
                  src={image10}
                  alt="image10"
                  className="object-cover w-full h-64 md:h-80 rounded-t-2xl hover:scale-105 transition duration-500 ease-in-out"
                />
                <div className="absolute inset-0 flex flex-col justify-center items-center px-6 py-8  rounded-b-2xl">
                  <div className="text-xl md:text-2xl font-bold text-center text-white">
                    {t("Tawkil Service")}
                  </div>
                  <div className="mt-4 text-center  text-white">
                    {t(
                      "Save time and streamline legal tasks by appointing a trusted representative for all your wedding documentation."
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*features*/}
      {/* Render FeatureCarousel component with features data */}
      <div className="px-5 pb-10">
        <div className="flex gap-5 max-md:flex-col max-md:gap-0">
          <div className="flex flex-col w-[23%] max-md:ml-0 max-md:w-full">
            <div className="flex flex-col grow max-md:mt-7">
              <video
                width="100%"
                height="auto"
                controls
                className="w-full aspect-[0.6] rounded-lg"
              >
                <source src={videoA} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
              <video
                width="100%"
                height="538px"
                controls
                className="mt-8 w-full aspect-[0.55] rounded-lg"
              >
                <source src={videoA} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
          <div className="flex flex-col ml-5 w-[24%] max-md:ml-0 max-md:w-full">
            <div className="flex flex-col grow font-bold text-white max-md:mt-7">
              <video
                width="100%"
                height="auto"
                controls
                className="w-full aspect-[0.44] rounded-lg"
              >
                <source src={videoA} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
              <div className="flex flex-col px-4 py-20 mt-6 rounded-lg hover:bg-pink-600 bg-blue-950 max-md:pr-5">
                <div className="self-center text-center text-4xl">340</div>
                <div className="mt-9 text-xl text-center">
                  {t("More than 340 notaires")}
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-col ml-5 w-[53%] max-md:ml-0 max-md:w-full">
            <div className="flex flex-col items-center justify-center h-full pt-16 pb-20">
              <h1 className="text-lg md:text-xl text-center text-stone-700">
                {t("Need Help?")}
              </h1>
              <div className="mt-4 md:ml-0 text-center">
                <h2 className="text-xl md:text-3xl font-bold tracking-tight text-gray-900">
                  {t("Expert Assistance at Your Fingertips")}
                  <br className="md:hidden" />
                </h2>
              </div>
              <p className="mt-4 text-gray-700 text-lg text-center">
                {t(
                  "Our platform connects you with seasoned professionals, including notaries and legal representatives, to ensure every legal aspect of your wedding is handled with precision and care. From document review to legal consultations, we&apos;ve got you covered every step of the way. We’re here to help."
                )}
              </p>
              <Link
                to="/LegalEducation"
                className="mt-6 px-6 py-3 md:px-8 md:py-4 text-lg md:text-xl text-white bg-pink-600 rounded-lg hover:bg-blue-950 hover:scale-105 transition duration-500 ease-in-out"
              >
                {t("Explore More")}
              </Link>
            </div>
            <video
              width="100%"
              height="auto"
              controls
              className="mt-16 w-full aspect-[1.74] max-md:mt-10 max-md:max-w-full rounded-lg"
            >
              <source src={videoD} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </div>

      {/*blogs*/}
      <div className="flex flex-col items-center px-5 font-bold pt-20 pb-16">
        <div className="flex flex-col items-center justify-center h-full pt-5 ">
          <h1 className="text-base md:text-lg lg:text-xl text-center text-stone-700">
            {t("BLOG INSIGHTS")}
          </h1>
          <div className="mt-4 md:ml-0 text-center">
            <h2 className="text-lg md:text-2xl lg:text-3xl font-bold tracking-tight text-gray-900">
              {t("Unlocking Marital Treasures: Explore")}{" "}
              <br className="hidden md:block" />
              {t("Insights and Inspiration on Marriage in Tunisia")}
            </h2>
          </div>
        </div>
        <div className="flex justify-center gap-5 items-center self-stretch mt-20 w-full text-base md:text-xl lg:text-2xl text-zinc-600 flex-wrap md:flex-nowrap">
          <Link
            to="/blog3"
            className="px-4 py-8 text-pink-600 rounded-xl transition duration-300 ease-in-out hover:bg-pink-600 hover:text-white border-2 border-pink-600 shadow-md"
          >
            {t("The Grand Finale")}
          </Link>
          <Link
            to="/blog5"
            className="px-4 py-8 text-pink-600 rounded-xl transition duration-300 ease-in-out hover:bg-pink-600 hover:text-white border-2 border-pink-600 shadow-md"
          >
            {t("Marriage with a non-Muslim")}
          </Link>
          <Link
            to="/blog1"
            className="px-4 py-8 text-pink-600 rounded-xl transition duration-300 ease-in-out hover:bg-pink-600 hover:text-white border-2 border-pink-600 shadow-md"
          >
            {t("Before the Wedding Day")}
          </Link>
          <Link
            to="/blog3"
            className="px-4 py-8 text-pink-600 rounded-xl transition duration-300 ease-in-out hover:bg-pink-600 hover:text-white border-2 border-pink-600 shadow-md"
          >
            {t("Prenuptial Agreement")}
          </Link>
        </div>
      </div>

      <div className="flex flex-col md:flex-row gap-5 pb-10 px-5">
        {/* Card 1 */}
        <div className="flex-grow flex-shrink w-full md:w-1/3">
          <Link to="/blog1">
            <div className="overflow-hidden rounded-lg shadow-lg bg-white hover:shadow-xl transition duration-300">
              <img
                loading="lazy"
                src={image9}
                className="w-full h-auto rounded-t-lg"
                alt="Image 1"
              />
              <div className="p-4">
                <h3 className="font-bold text-lg text-gray-900 mb-2">
                  {t("Before the Wedding Day")}
                </h3>
                <p className="text-gray-700 text-sm">
                  {t(
                    "A Week of Preparation and Celebration in Tunisian Weddings."
                  )}
                </p>
                <div className="flex items-center mt-3">
                  <div className="flex-shrink-0">
                    <div className="h-10 w-10 rounded-full flex items-center justify-center bg-red-300 text-white font-bold text-sm">
                      H
                    </div>
                  </div>
                  <div className="ml-3">
                    <p className="text-xs text-gray-600">{t("Hayya Team")}</p>
                    <p className="text-xs text-zinc-600">
                      {t("June 18, 2024")}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Link>
        </div>

        {/* Card 2 */}
        <div className="flex-grow flex-shrink w-full md:w-1/3">
          <Link to="/blog2">
            <div className="overflow-hidden rounded-lg shadow-lg bg-white hover:shadow-xl transition duration-300">
              <img
                loading="lazy"
                src={image8}
                className="w-full h-auto rounded-t-lg"
                alt="Image 2"
              />
              <div className="p-4">
                <h3 className="font-bold text-lg text-gray-900 mb-2">
                  {t("The Wedding Day")}
                </h3>
                <p className="text-gray-700 text-sm">
                  {t(
                    "The Big Day Arrives! A Celebration of Love in Tunisian Weddings."
                  )}
                </p>
                <div className="flex items-center mt-3">
                  <div className="flex-shrink-0">
                    <div className="h-10 w-10 rounded-full flex items-center justify-center bg-red-300 text-white font-bold text-sm">
                      H
                    </div>
                  </div>
                  <div className="ml-3">
                    <p className="text-xs text-gray-600">{t("Hayya Team")}</p>
                    <p className="text-xs text-zinc-600">
                      {t("June 22, 2024")}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Link>
        </div>

        {/* Card 3 */}
        <div className="flex-grow flex-shrink w-full md:w-1/3">
          <Link to="/blog3">
            <div className="overflow-hidden rounded-lg shadow-lg bg-white hover:shadow-xl transition duration-300">
              <img
                loading="lazy"
                src={image6}
                className="w-full h-auto rounded-t-lg"
                alt={t("Image 3")}
              />
              <div className="p-4">
                <h3 className="font-bold text-lg text-gray-900 mb-2">
                  {t("Prenuptial Agreement and Islamic Marriage")}
                </h3>
                <p className="text-gray-700 text-sm">
                  {t(
                    "Prenuptial Agreements and Islamic Marriage in Tunisia: Combining Love and Legality."
                  )}
                </p>
                <div className="flex items-center mt-3">
                  <div className="flex-shrink-0">
                    <div className="h-10 w-10 rounded-full flex items-center justify-center bg-red-300 text-white font-bold text-sm">
                      H
                    </div>
                  </div>
                  <div className="ml-3">
                    <p className="text-xs text-gray-600">{t("Hayya Team")}</p>
                    <p className="text-xs text-zinc-600">
                      {t("June 23, 2024")}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Link>
        </div>
      </div>

      {/*FQS*/}
      <div>
        <div className="py-20 bg-gray-50">
          <div className="container mx-auto flex flex-col lg:flex-row gap-10 lg:gap-20">
            <div className="lg:w-1/2 px-5 lg:px-0">
              <div className="flex flex-col lg:pr-20">
                <h2 className="text-lg md:text-xl text-center text-stone-700">
                  {t("QUESTION ANSWER")}
                </h2>
                <div className="mt-4 md:ml-0 text-center">
                  <h2 className="text-xl md:text-3xl font-bold tracking-tight text-gray-900">
                    {t("Frequently Asked Questions")}
                  </h2>
                </div>
                <img
                  src={image5}
                  loading="lazy"
                  alt="FAQ Image"
                  className="mt-8 w-full rounded-lg transition-transform duration-500 ease-in-out hover:scale-105"
                />
              </div>
            </div>
            <div className="lg:w-1/2 px-5 lg:px-0">
              <div className="flex flex-col text-center lg:text-left text-2xl font-medium text-black">
                <p className="text-2xl text-zinc-600 mb-10">
                  {t("If you have any other questions or need further")} <br />
                  {t("clarification, feel free to reach out to our")} <br />
                  {t("friendly team.")}
                </p>
                <div className="space-y-6">
                  {questions.map((question, index) => (
                    <QuestionCard key={index} question={question} />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        {showCookieNotice && (
          <CookieNoticePopup onDismiss={handleDismissCookieNotice} />
        )}
      </div>
      <Suspense fallback={<div>Loading...</div>}>
        <Footer />
      </Suspense>
    </div>
  );
}
